export default function Dialog({ open = true, title, description, children, footer, onClose, width = 460, style, ...rest }) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{ position: "fixed", inset: 0, zIndex: 60, display: "flex", alignItems: "center", justifyContent: "center", padding: "var(--space-4)" }}
    >
      <div
        onClick={onClose}
        style={{ position: "absolute", inset: 0, background: "color-mix(in srgb, var(--ink-950) 46%, transparent)", backdropFilter: "blur(3px)" }}
      />
      <div
        style={{
          position: "relative",
          width,
          maxWidth: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          background: "var(--surface-raised)",
          borderRadius: "var(--radius-2xl)",
          boxShadow: "var(--shadow-xl)",
          padding: "var(--space-6)",
          fontFamily: "var(--font-body)",
          animation: "trybDialogIn var(--dur-slow) var(--ease-spring)",
          ...style,
        }}
        {...rest}
      >
        {onClose && (
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            style={{
              position: "absolute", top: 16, right: 16, border: "none", background: "var(--surface-sunken)",
              width: 34, height: 34, borderRadius: "50%", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-secondary)",
            }}
          >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        )}
        {title && (
          <h2 style={{ margin: "0 40px 6px 0", fontFamily: "var(--font-display)", fontSize: "var(--text-xl)", fontWeight: "var(--weight-bold)", color: "var(--text-primary)", letterSpacing: "var(--tracking-snug)" }}>
            {title}
          </h2>
        )}
        {description && (
          <p style={{ margin: "0 0 var(--space-5)", fontSize: "var(--text-base)", lineHeight: "var(--leading-normal)", color: "var(--text-secondary)" }}>
            {description}
          </p>
        )}
        {children}
        {footer && <div style={{ display: "flex", justifyContent: "flex-end", gap: "var(--space-3)", marginTop: "var(--space-6)" }}>{footer}</div>}
      </div>
    </div>
  );
}
